import axios from "axios";
import { LOGINURL, LOGOUTURL, SIGNUPURL, FORGOTURL, USERAPIURL } from "../helpers/constants";



export const getqrtoken = function(userid) {
  let url=`${USERAPIURL}/${userid}/request_qr_login_token`;
  return axios.post(url,null, {withCredentials: true });
}

export const login = function (uname, pw) {
  console.log("login api", uname, pw);
  let payload = {
    username: uname,
    password: pw
  };
  return axios
    .post(LOGINURL, payload, { withCredentials: true })
}

export const logout = function () {
  console.log("logout api");

  return axios
    .post(LOGOUTURL, {}, { withCredentials: true })
}

export const signup = function (uname, pw) {
  console.log("signup api", uname, pw);
  let payload = {
    username: uname,
    password: pw
  };
  return axios
    .post(SIGNUPURL, payload, { withCredentials: true })
}

export const forgotPW = function (uname) {
  console.log("forgot pw api", uname);
  let payload = {
    username: uname
  };
  return axios
    .post(FORGOTURL, payload, { withCredentials: true })
}
